import { ModalContent, Button } from 'components';
import { useAuth } from 'hooks';

interface Props {
  handleClose: () => void;
}

export function ConfirmExitModal({ handleClose }: Props) {
  const { signOut } = useAuth();

  return (
    <ModalContent handleClose={handleClose}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2 text-neutral-500">
          <span className="text-base font-bold">
            Quer sair do Retire & Entrega?
          </span>

          <p className="text-xs max-w-96">
            Ao sair, você será desconectado da loja e precisará fazer login de
            novo para acessar.
          </p>
        </div>

        <div className="flex gap-4">
          <Button onClick={handleClose} variant="secondary" full>
            Voltar
          </Button>

          <Button onClick={signOut} variant="danger" full>
            Sair agora
          </Button>
        </div>
      </div>
    </ModalContent>
  );
}
